import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { LuKey, LuMenu, LuMoon, LuPen, LuPoundSterling, LuSearch, LuSun, LuX } from 'react-icons/lu'
import AuthControls from './AuthControls.jsx'
import { useTheme } from '../context/ThemeContext.jsx'
import { useAffordability } from '../context/AffordabilityContext.jsx'

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Search', to: '/listings' },
  { label: 'Buyer hub', to: '/buy' },
  { label: 'Sell', to: '/sell' },
]

const Navbar = ({ authEnabled }) => {
  const location = useLocation()
  const [isCompact, setIsCompact] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const { theme, toggleTheme } = useTheme()
  const { toggleSidebar, hasProfile } = useAffordability()

  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    const COMPACT_SCROLL = 140
    const EXPAND_SCROLL = 40

    const handleScroll = () => {
      const y = window.scrollY
      setIsCompact((prev) => {
        if (!prev && y > COMPACT_SCROLL) return true
        if (prev && y < EXPAND_SCROLL) return false
        return prev
      })
    }

    // initialize state
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <header className={`nav-bar ${isCompact ? 'is-compact' : ''}`}>
      <div className="nav-bar__brand">
        <Link className="brand-mark" to="/">
          <span className="brand-mark__emblem">
            <span className="brand-mark__icon" aria-hidden="true">
              <LuKey />
            </span>
            <span className="brand-mark__wordmark">KEYZEE</span>
          </span>
        </Link>
        <button
          type="button"
          className={`nav-toggle ${menuOpen ? 'is-open' : ''}`}
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? <LuX aria-hidden="true" /> : <LuMenu aria-hidden="true" />}
        </button>
      </div>

      <nav className={`nav-links ${menuOpen ? 'is-open' : ''}`} aria-label="Primary navigation">
        {NAV_LINKS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={location.pathname === item.to ? 'active' : undefined}
            aria-current={location.pathname === item.to ? 'page' : undefined}
            onClick={() => setMenuOpen(false)}
          >
            {item.label}
          </Link>
        ))}
      </nav>


      <div className={`nav-actions ${menuOpen ? 'is-open' : ''}`}>
        {authEnabled ? (
          <AuthControls onNavClose={() => setMenuOpen(false)} />
        ) : (
          <></>
        )}

        <button
          type="button"
          className={`nav-theme-toggle${hasProfile ? ' nav-affordability-active' : ''}`}
          aria-label="Affordability calculator"
          title="Affordability calculator"
          onClick={toggleSidebar}
        >
          <LuPoundSterling aria-hidden="true" />
        </button>

        <button
          type="button"
          className="nav-theme-toggle"
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={toggleTheme}
        >
          {theme === 'dark' ? <LuSun aria-hidden="true" /> : <LuMoon aria-hidden="true" />}
        </button>

        <Link to="/sell" className="secondary-button pill-action" onClick={() => setMenuOpen(false)}>
          <LuPen aria-hidden="true" /> List your home
        </Link>
        <Link to="/listings" className="primary-button pill-action" onClick={() => setMenuOpen(false)}>
          <LuSearch aria-hidden="true" /> Find a home
        </Link>
      </div>
    </header>
  )
}

export default Navbar
